import { ElementRef, Input } from '@angular/core';
import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	HostListener,
} from "@angular/core";
import { AppSidebarModelService } from "./app-sidebar-model.service";
import { AppServices } from "app/app.services";
import { CustomDoc } from "../../vo/custom-doc";
import { DxScrollViewModule, DxScrollViewComponent } from "devextreme-angular";
import { OrientationModelService } from "app/core/models/orientation-model.service";
import { OrientationService } from "app/services/orientation.service";
import { CourseControllerService } from "app/core/controls/course-controller.service";
import { UtilityScripts } from "app/helpers/utility-scripts";
@Component({
	selector: "app-app-sidebar",
	templateUrl: "./app-sidebar.component.html",
	styleUrls: ["./app-sidebar.component.css"],
})
export class AppSidebarComponent implements OnInit {
	private bAudioMode: boolean = true;
	public isMobile: Boolean = false;
	public iOSDevice: Boolean = false;
	@Output("audioOn") _bAudioMode: EventEmitter<boolean> = new EventEmitter();
	@Output() closeSidebar: EventEmitter<string> = new EventEmitter();
	@Input() sidebar_inner_wrap: string;
	@Input() coursePlayerVersion: string;
	@Output() sidebarMenuClicked: EventEmitter<string> = new EventEmitter();
	private LEFT_MENU: String = "leftMenu";
	private stepIndex: number = 0;

	constructor(
		private appSidebarModelService: AppSidebarModelService,
		private appService: AppServices,
		public orientationModel: OrientationModelService,
		public orientationService: OrientationService,
		private CourseControllerService: CourseControllerService,
		private elementRef: ElementRef
	) {}

	public ngOnInit() {
		this._bAudioMode.emit(this.bAudioMode);
		this.iOSDevice = navigator.platform.indexOf("MacIntel") != -1;
		this.isMobile =
			window.innerWidth <= 1024 &&
			(UtilityScripts.isMobileDevice() || this.iOSDevice)
				? true
				: false;
		if (this.isMobile) {
			this.closeMenu();
		}
	}

	@HostListener("window:resize") onResize() {
		const OS: any = UtilityScripts.getSystemDetails()["os"];
		const _iOSDevice =
			OS.toLowerCase().indexOf("ios") != -1 ||
			OS.toLowerCase().indexOf("mac os x") != -1;
		const _androidDevice = OS.toLowerCase().indexOf("android") != -1;
		const touchDevice = UtilityScripts.detectTouchscreen();
		if (
			window.innerWidth > 1024 &&
			!_iOSDevice &&
			!_androidDevice &&
			!touchDevice
		) {
			this.closeSidebar.emit(`page-inner-wrap`);
		}
	}

	public moduleClick(selectedMod: any, event): void {
		event.preventDefault();
		if (
			(this.isMobile && selectedMod.courseModule.module_open) ||
			(this.isMobile && selectedMod.childScenes.length === 1)
		) {
			this.closeMenu();
		}
		this.appSidebarModelService.moduleClick(selectedMod, event);
		this.sidebarMenuClicked.emit("module_click");
	}

	public sceneClick(selectedScene: any, event): void {
		event.preventDefault();
		if (this.isMobile) {
			this.closeMenu();
		}
		this.appSidebarModelService.sceneClick(selectedScene);
		this.sidebarMenuClicked.emit("scene_click");
	}

	public closeMenu() {
		this.closeSidebar.emit(`page-inner-wrap toggled`);
	}

	public toggleAudioMode() {
		this.bAudioMode = !this.bAudioMode;
		this._bAudioMode.emit(this.bAudioMode);
	}

	public get bAudioModeVal(): boolean {
		return this.bAudioMode;
	}

	public get appSidebarModelServiceVal(): AppSidebarModelService {
		return this.appSidebarModelService;
	}
	public set appSidebarModelServiceVal(val) {
		this.appSidebarModelService = val;
	}
	public menuImages(menuItemId: string): string {
		return this.appSidebarModelService.getMenuImage(menuItemId);
	}
	public backDropClck(event: any) {
		this.closeMenu();
	}

	public handleSkipTo(query: string, e) {
		e.preventDefault();
		const htmlElement =
		this.elementRef.nativeElement.parentElement.querySelector(query);
		if (htmlElement) {
		htmlElement.focus();
		}
	}
}
